import { AccountState } from '@app/modules/admin/providers/user-management/user-management.enums';
import { OTPType } from './auth.constants';

import { SocialLoginProvider, TwoFATypes } from './auth.structs';
import { ActiveSession } from '@app/modules/trading/modules/profile/components/personal-details/interfaces/personal-details.interfaces';
import { brokerData } from '@app/modules/trading/modules/manage-brokers/manage-broker.interface';
import { LoginFlowType } from '@app/modules/trading/modules/manage-brokers/manage-broker.enums';

export interface SocialLogin {
    provider: SocialLoginProvider;
    image: string;
    fixed?: boolean;
}

export interface SocialLoginInitResponse {
    auth_link: string;
    status: string;
}

export interface PhoneLoginResponse {
    access: string;
    message: string;
    isFirstLogin: boolean;
    refresh: string;
    status: string;
    signup: boolean;
}

export interface LoginResponse {
    access: string;
    message: string;
    isFirstLogin: boolean;
    refresh: string;
    status: string;
    password_state: AccountState;
    activeSessions: ActiveSession[];
    consentToken: string;

    // For user details
    full_name?: string;
    email?: string;
}

export interface UserInfo {
    access: string;
    refresh: string;
}

export interface PhoneLoginRequest {
    phone: string;
}

export interface LoginRequest {
    userid?: string;
    email?: string;
    password: string;
    crmUtmFields?: ReffererStructure;
}

export interface OperatorLoginRequest {
    username: string;
    password: string;
    totp_secret: string;
}

export interface SwastikaLoginRequest {
    user_id?: string;
    mpin?: number;
    totp_key?: string;
}

export interface MastertrustLoginRequest {
    user_id: string;
    password: string;
    totp_key: string;
}

export interface TwoFAEnabledResponse {
    twoFA: boolean;
    reset_mpin: boolean;
    twoFA_token: string;
    twoFA_type: TwoFATypes;
    password_state: AccountState;
}

export interface MPINReqest {
    oldMPin?: number;
    mpin: number;
    twoFaToken?: string;
}

export interface SignUpRequest {
    email: string;
    password: string;
    mobile: string;
    fullName: string;
    crmUtmFields?: ReffererStructure;
}

export interface ReffererStructure {
    utm_source: string;
    utm_campaign: string;
    utm_content: string;
    utm_medium: string;
    Referrer_URL: string;
    IP: string;
    referral_code: string;
}


export interface ValidateOTPResponse {
    isValidOTP: boolean;
    otpType: OTPType;
    status?: string;
    message?: string;
    activeSessions?: ActiveSession[];
    consentToken?: string;
}

export interface VerifyEmailRequest {
    email: string;
    otp: string;
    mobileOtp?: string;
}

export interface VerifyPhoneRequest {
    phone: string;
    otp: string;
}

export interface GenericResponse {
    message: string;
    status: string;
}

export interface ChangePasswordRequest {
    oldPassword: string;
    newPassword: string;
    accessToken?: string;
    resetToken?: string;
}

export interface RefreshPasswordResponse {
    access: string;
    message: string;
    status: string;
}

export interface PasswordPolicyInterface {
    description: string;
    max2FaAttemptsAllowed: number;
    max2FaLengthAllowed: number;
    maxPasswordAttemptsAllowed: number;
    passwordPolicyRegularExpression: string;
}

// Broker related interfaces

export type MultiBrokerEmailPhoneLoginRequest = {
    mobile_number?: string;
    email?: string;
}

export type MultiBrokerEmailPhoneLoginResponse = {
    email?: string;
    expires_in?: number;
    mobile_number?: string;
    message?: string;
    error?: string;
    status?: string;
    attempts_made?: number;
    attempts_remaining?: number;
    blocked?: boolean;
    block_duration_minutes?: number;
    redirect_login?: boolean;
    session_id?: string;
}

export type MultiBrokerVerifyOTPRequest = {
    mobile_number?: string;
    email?: string;
    otp: string;
    session_id?: string;
}

export type MultiBrokerRefreshTokenResponse = {
    access_token?: string;
    refresh_token?: string;
    expires_at?: number;
    error?: string;
    status?: string;
    email?: string;
}

export type MultiBrokerVerifyOTPResponse = {
    error?: string;
    message?: string;
    status?: string;
    data?: MultiBrokerRefreshTokenResponse;
    success?: boolean;
    broker_data?: brokerData;
    attempts_remaining?: number;
    attempts_made?: number;
    wrong_otp?: boolean;
    blocked?: boolean;
    redirect_login?: boolean;
    block_duration_minutes?: number;
    isFirstLogin?: boolean;

    full_name?: string;
    email?: string;
}

export interface MultiBrokerSocialLoginInitResponse {
    redirect_url?: string;
    success?: boolean;
    error?: string;
    status?:string;
}